// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.session-drawer-paper {
  width: 80vw !important;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Hide all scrollbar arrow buttons inside the drawer */
.session-drawer-paper *::-webkit-scrollbar-button,
.session-drawer-paper::-webkit-scrollbar-button {
  display: none;
  height: 0;
  width: 0;
}

/* body */

.sessioclosing-top-bar {
  display: flex;
  padding: 16px 24px;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
  border-bottom: 1px solid var(--Gray-200, #e9eaec);
  background: #fff;
}

.session-title-wrapper {
  display: flex;
  width: 339px;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.session-title-p {
  color: var(--Black, #000);

  /* Text md/Bold */
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.session-subtitle-p {
  color: var(--Gray-700, #414652);

  /* Text xs/Regular */
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  align-self: stretch;
}

.session-left-side-wrapper {
  display: flex;
  gap: 4px;
}

.session-closing-body {
  display: flex;
  padding: 12px 24px;
  flex-direction: column;
  align-items: flex-end;
  gap: 16px;
  flex: 1 0 0;
  align-self: stretch;
  border: none;
  background: transparent;
  /* overflow-y: scroll; */
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 #f1f5f9;
}

.session-closing-body::-webkit-scrollbar {
  width: 6px;
}

.session-closing-body::-webkit-scrollbar-button {
  display: none;
}

.session-closing-body::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 4px;
}

.session-closing-body::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.session-closing-body::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.sesion-closing-current-session-detail {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
}

.sesion-closing-current-session-detail-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
}

.session-detail-top-p {
  color: var(--Black, #000);

  /* Text sm/Bold */
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.sesion-closing-current-session-detail-body {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  align-items: center;
  gap: 12px;
  align-self: stretch;
}

.current-session-detail-body-summary-card {
  /* border-radius: 8px;
  border: 1px solid var(--Gray-200, #e9eaec);
  background: #fff;
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  flex: 1 0 0;
  align-self: stretch; */

  background-color: #ffffff;
  padding: 1.5rem; /* 6 * 0.25rem = 1.5rem */
  border-radius: 1rem; /* 2xl = 1rem */
  border: 1px solid #f1f5f9; /* slate-100 */
  box-shadow: 0 4px 5px 0 rgb(0 0 0 / 0.05); /* sm shadow */
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 0.5rem; /* 2 * 0.25rem = 0.5rem */
}

.summary-card-logo-section {
  border-radius: 24px;

  display: flex;
  padding: 10px;
  align-items: center;
  gap: 10px;
}

.summary-card-label-value-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  align-self: stretch;
}

.summary-card-label {
  color: var(--Gray-400, #a4a7af);
  text-align: center;

  /* Text xs/Semibold */
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  align-self: stretch;
}

.summary-card-value {
  align-self: stretch;
  color: var(--Black, #000);
  text-align: center;

  /* Text md/Bold */
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.sesion-closing-current-sesion-body {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 16px;
  align-self: stretch;
}

.current-sesion-body-p {
  color: var(--Black, #000);

  /* Text sm/Bold */
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.sesion-closing-current-sesion-body-top-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
}

.session_closing_home_page-container {
  flex: 1 1 0%;
  overflow-y: scroll;
  z-index: 10;
  padding-top: 2rem;
  padding-bottom: 2rem;
  width: 100%;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 #f1f5f9;
}

.session_closing_home_page-container::-webkit-scrollbar {
  width: 6px;
}

.session_closing_home_page-container::-webkit-scrollbar-button {
  display: none;
}

.session_closing_home_page-container::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 4px;
}

.session_closing_home_page-container::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.session_closing_home_page-container::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
/* ── Revamp styles ───────────────────────────────────────────────── */

.session-closing-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
  padding-bottom: 16px;
  /* border-bottom: 1px solid var(--Gray-200, #e9eaec); */
  margin-bottom: 4px;
}

.session-closing-header-left {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.session-closing-header-title {
  font-family: "Outfit", "Inter", sans-serif;
  line-height: normal;
  display: flex;
  margin: 0;
}

.session-closing-header-subtitle {
  color: var(--Gray-500, #717680);
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: normal;
  margin-top: 0.25rem;
  color: #64748b;
}

.session-closing-header-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.session-closing-header-close-btn {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  color: #6b7280;
  border-radius: 4px;
  transition: background 0.15s;
}

.session-closing-header-close-btn:hover {
  background: #f3f4f6;
}

.session-close-cta-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  align-self: stretch;
  padding: 28px 24px;
  border-radius: 16px;
  border: 1px solid #f1f5f9;
  background: #f8fafc;
  text-align: center;
}

.session-close-cta-title {
  color: var(--Black, #000);
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 15px;
  font-weight: 700;
  line-height: normal;
  margin: 0;
}

.session-close-cta-subtitle {
  color: var(--Gray-500, #717680);
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.6;
  margin: 0;
  max-width: 380px;
}

.session-close-cta-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #e8003d;
  color: #fff;
  border: none;
  border-radius: 50px;
  padding: 12px 28px;
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition:
    background 0.15s,
    opacity 0.15s;
  margin-top: 4px;
}

.session-close-cta-btn:hover {
  background: #c4002f;
}

.session-close-cta-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.session-close-cta-btn svg {
  width: 16px;
  height: 16px;
}

.session-status-active-button {
  margin-left: 12px;
  margin-top: 4px;
}

.session-closing-header-title-p {
  flex-shrink: 0;
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: 700;
  color: #0f172a;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/posnavbar/components/SessionClosingDrawer/sessionClosingDrawer.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;;EAEE,aAAa;EACb,SAAS;EACT,QAAQ;AACV;;AAEA,SAAS;;AAET;EACE,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,yBAAyB;;EAEzB,iBAAiB;EACjB,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;;EAE/B,oBAAoB;EACpB,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;;EAEzB,iBAAiB;EACjB,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;;;;;;;;;wBASsB;;EAEtB,yBAAyB;EACzB,eAAe,EAAE,yBAAyB;EAC1C,mBAAmB,EAAE,eAAe;EACpC,yBAAyB,EAAE,cAAc;EACzC,yCAAyC,EAAE,cAAc;EACzD,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW,EAAE,yBAAyB;AACxC;;AAEA;EACE,mBAAmB;;EAEnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;;EAElB,qBAAqB;EACrB,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;;EAElB,iBAAiB;EACjB,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;;EAEzB,iBAAiB;EACjB,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;EACX,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;AACA,uEAAuE;;AAEvE;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,uDAAuD;EACvD,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf;;iBAEe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":[".session-drawer-paper {\n  width: 80vw !important;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n/* Hide all scrollbar arrow buttons inside the drawer */\n.session-drawer-paper *::-webkit-scrollbar-button,\n.session-drawer-paper::-webkit-scrollbar-button {\n  display: none;\n  height: 0;\n  width: 0;\n}\n\n/* body */\n\n.sessioclosing-top-bar {\n  display: flex;\n  padding: 16px 24px;\n  justify-content: space-between;\n  align-items: flex-start;\n  align-self: stretch;\n  border-bottom: 1px solid var(--Gray-200, #e9eaec);\n  background: #fff;\n}\n\n.session-title-wrapper {\n  display: flex;\n  width: 339px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n}\n\n.session-title-p {\n  color: var(--Black, #000);\n\n  /* Text md/Bold */\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.session-subtitle-p {\n  color: var(--Gray-700, #414652);\n\n  /* Text xs/Regular */\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  align-self: stretch;\n}\n\n.session-left-side-wrapper {\n  display: flex;\n  gap: 4px;\n}\n\n.session-closing-body {\n  display: flex;\n  padding: 12px 24px;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 16px;\n  flex: 1 0 0;\n  align-self: stretch;\n  border: none;\n  background: transparent;\n  /* overflow-y: scroll; */\n  scrollbar-width: thin;\n  scrollbar-color: #cbd5e1 #f1f5f9;\n}\n\n.session-closing-body::-webkit-scrollbar {\n  width: 6px;\n}\n\n.session-closing-body::-webkit-scrollbar-button {\n  display: none;\n}\n\n.session-closing-body::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 4px;\n}\n\n.session-closing-body::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 4px;\n}\n\n.session-closing-body::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n.sesion-closing-current-session-detail {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n  align-self: stretch;\n}\n\n.sesion-closing-current-session-detail-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  align-self: stretch;\n}\n\n.session-detail-top-p {\n  color: var(--Black, #000);\n\n  /* Text sm/Bold */\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.sesion-closing-current-session-detail-body {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1fr;\n  align-items: center;\n  gap: 12px;\n  align-self: stretch;\n}\n\n.current-session-detail-body-summary-card {\n  /* border-radius: 8px;\n  border: 1px solid var(--Gray-200, #e9eaec);\n  background: #fff;\n  display: flex;\n  padding: 16px;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  flex: 1 0 0;\n  align-self: stretch; */\n\n  background-color: #ffffff;\n  padding: 1.5rem; /* 6 * 0.25rem = 1.5rem */\n  border-radius: 1rem; /* 2xl = 1rem */\n  border: 1px solid #f1f5f9; /* slate-100 */\n  box-shadow: 0 4px 5px 0 rgb(0 0 0 / 0.05); /* sm shadow */\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 0.5rem; /* 2 * 0.25rem = 0.5rem */\n}\n\n.summary-card-logo-section {\n  border-radius: 24px;\n\n  display: flex;\n  padding: 10px;\n  align-items: center;\n  gap: 10px;\n}\n\n.summary-card-label-value-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  align-self: stretch;\n}\n\n.summary-card-label {\n  color: var(--Gray-400, #a4a7af);\n  text-align: center;\n\n  /* Text xs/Semibold */\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  align-self: stretch;\n}\n\n.summary-card-value {\n  align-self: stretch;\n  color: var(--Black, #000);\n  text-align: center;\n\n  /* Text md/Bold */\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.sesion-closing-current-sesion-body {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 16px;\n  align-self: stretch;\n}\n\n.current-sesion-body-p {\n  color: var(--Black, #000);\n\n  /* Text sm/Bold */\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.sesion-closing-current-sesion-body-top-section {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n  align-self: stretch;\n}\n\n.session_closing_home_page-container {\n  flex: 1 1 0%;\n  overflow-y: scroll;\n  z-index: 10;\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n  width: 100%;\n  scrollbar-width: thin;\n  scrollbar-color: #cbd5e1 #f1f5f9;\n}\n\n.session_closing_home_page-container::-webkit-scrollbar {\n  width: 6px;\n}\n\n.session_closing_home_page-container::-webkit-scrollbar-button {\n  display: none;\n}\n\n.session_closing_home_page-container::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 4px;\n}\n\n.session_closing_home_page-container::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 4px;\n}\n\n.session_closing_home_page-container::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n/* ── Revamp styles ───────────────────────────────────────────────── */\n\n.session-closing-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  align-self: stretch;\n  padding-bottom: 16px;\n  /* border-bottom: 1px solid var(--Gray-200, #e9eaec); */\n  margin-bottom: 4px;\n}\n\n.session-closing-header-left {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.session-closing-header-title {\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  line-height: normal;\n  display: flex;\n  margin: 0;\n}\n\n.session-closing-header-subtitle {\n  color: var(--Gray-500, #717680);\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: normal;\n  margin-top: 0.25rem;\n  color: #64748b;\n}\n\n.session-closing-header-right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.session-closing-header-close-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px;\n  color: #6b7280;\n  border-radius: 4px;\n  transition: background 0.15s;\n}\n\n.session-closing-header-close-btn:hover {\n  background: #f3f4f6;\n}\n\n.session-close-cta-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  align-self: stretch;\n  padding: 28px 24px;\n  border-radius: 16px;\n  border: 1px solid #f1f5f9;\n  background: #f8fafc;\n  text-align: center;\n}\n\n.session-close-cta-title {\n  color: var(--Black, #000);\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 15px;\n  font-weight: 700;\n  line-height: normal;\n  margin: 0;\n}\n\n.session-close-cta-subtitle {\n  color: var(--Gray-500, #717680);\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 1.6;\n  margin: 0;\n  max-width: 380px;\n}\n\n.session-close-cta-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: #e8003d;\n  color: #fff;\n  border: none;\n  border-radius: 50px;\n  padding: 12px 28px;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition:\n    background 0.15s,\n    opacity 0.15s;\n  margin-top: 4px;\n}\n\n.session-close-cta-btn:hover {\n  background: #c4002f;\n}\n\n.session-close-cta-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.session-close-cta-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n.session-status-active-button {\n  margin-left: 12px;\n  margin-top: 4px;\n}\n\n.session-closing-header-title-p {\n  flex-shrink: 0;\n  font-size: 1.5rem;\n  line-height: 2rem;\n  font-weight: 700;\n  color: #0f172a;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
